import { Navigate, useSearchParams } from 'react-router-dom';

export default function AdminAuthPage() {
  const [params] = useSearchParams();
  const returnTo = params.get('returnTo') ?? '/admin';
  return <Navigate to={`/staff-auth?returnTo=${encodeURIComponent(returnTo)}`} replace />;
}
